import React from 'react';
import { useNavigate } from 'react-router-dom';

const DomainSelector: React.FC = () => {
  const navigate = useNavigate();

  const domains = [
    { name: 'Clothing Agent', slug: 'clothing demo', enabled: true },
    { name: 'Legal', slug: 'legal', enabled: false },
    { name: 'Patents', slug: 'patents', enabled: false },
    { name: 'Subsidies', slug: 'subsidies', enabled: false },
    { name: 'More...', slug: 'more', enabled: false },
  ];

  const handleDomainClick = (slug: string) => {
    navigate(`/agentic?agent=rhea_domain&domain=${slug}`);
  };

  return (
    <div className="flex flex-col items-center justify-center h-full p-8">
      <h1 className="text-2xl font-semibold mb-8" style={{ color: 'var(--rhea-text-primary)' }}>
        Select a Domain
      </h1>
      <div className="grid grid-cols-1 gap-4 w-full max-w-md">
        {domains.map((domain) => (
          <button
            key={domain.slug}
            onClick={() => domain.enabled && handleDomainClick(domain.slug)}
            className={`
              p-4 rounded-lg text-left transition-all duration-200 relative
              ${domain.enabled 
                ? 'bg-[var(--rhea-accent-primary)] hover:bg-[var(--rhea-card-hover)] cursor-pointer border border-[var(--rhea-card-border)]' 
                : 'bg-[var(--rhea-card-bg)] opacity-50 cursor-not-allowed border border-[var(--rhea-card-border)]'
              }
            `}
            disabled={!domain.enabled}
          >
            <div className="flex justify-between items-center">
              <span className="text-lg" style={{ color: 'var(--rhea-text-primary)' }}>
                Chat with {domain.name}
              </span>
              {!domain.enabled && (
                <span className="text-sm px-2 py-1 rounded-full bg-[var(--rhea-card-hover)]" style={{ color: 'var(--rhea-text-secondary)' }}>
                  Coming Soon
                </span>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default DomainSelector; 